import { Box, Card, CardHeader, CardBody, Heading, Text, Button } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { EmailBillingForm } from '@/components/forms/EmailBillingForm'
import { shippingLineNameFromSearchParams } from '@/lib/navigation/financialStatementsSearchParams'

export default function EmailBillingToClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const params = useParams<{ shippingLineId: string; billingId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const billingStatementId = params.billingId ? parseInt(params.billingId, 10) : undefined

  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId = paramsShippingLineId
  const finalBillingStatementId = billingStatementId
  const validBillingStatementId =
    typeof finalBillingStatementId === 'number' && Number.isFinite(finalBillingStatementId)
      ? finalBillingStatementId
      : null

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Email Billing Statement to Client
            </Heading>
          </CardHeader>
          <CardBody>
            {validBillingStatementId == null ? (
              <Box>
                <Text color={colors.textSecondary} mb={4}>
                  Invalid Billing Statement. Cannot send email.
                </Text>
                <Button size="sm" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
              </Box>
            ) : (
              <EmailBillingForm
                shippingLineName={shippingLineName}
                billingStatementId={validBillingStatementId}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            )}
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
